/*
  This code defines a JavaScript module for handling recommended products display, including initializing a swiper component and equalizing card heights.

  - recommendProducts(recommendedProductIds, productId): A function that returns an object representing the recommended products module. It includes properties:
    - swiperInstance: Initialized as null, represents the swiper component instance.
    - recommendedProductIds: An array of recommended product IDs, defaults to an empty array.
    
  - Methods:
    - init(): Initializes the module by caching nodes and building the swiper.
    - recommendedProducts: Getter function that transforms recommended product IDs into an array of objects.
    - cacheNodes(): Caches the swiper element reference.
    - equalizeCardHeights(): Adjusts card heights to ensure uniform display.
    - buildSwiper(): Initializes the swiper component with specified configurations and event listeners for resizing and initialization.

  The module is then registered with Alpine.js to be used in the HTML as a component.
*/

const recommendProducts = (recommendedProductIds, productId) => ({
  swiperInstance: null,
  recommendedProductIds: recommendedProductIds || [],

  async init() {
    this.cacheNodes();
    this.buildSwiper();
  },

  get recommendedProducts() {
    const recommendedProds = [];
    recommendedProductIds?.map((id) => {
      recommendedProds.push({ id: id });
    });
    return recommendedProds;
  },

  cacheNodes() {
    this.swiperEl = this.$refs.swiper;
  },

  equalizeCardHeights() {
    const cards = this.$el.querySelectorAll('.product-card--link-card');
    let maxHeight = 0;

    cards.forEach((card) => {
      card.style.paddingBottom = '';
    });

    cards.forEach((card) => {
      if (card.clientHeight > maxHeight) {
        maxHeight = card.clientHeight;
      }
    });
    cards.forEach((card) => {
      const currentHeight = card.clientHeight;
      const difference = maxHeight - currentHeight;
      if (difference > 0) {
        card.style.paddingBottom = `${difference}px`;
      }
    });
  },

  buildSwiper() {
    if (!this.swiperEl) {
      return;
    }
    this.swiperInstance = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      mousewheel: false,
      scrollbar: {
        el: this.swiperEl.querySelector('.swiper-scrollbar'),
        hide: true,
      },
      navigation: {
        nextEl: this.swiperEl.querySelector('.swiper-button-next'),
        prevEl: this.swiperEl.querySelector('.swiper-button-prev'),
        disabledClass: 'swiper-button-dull',
      },
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      breakpoints: {
        1024: {
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
      },
      on: {
        init: () => {
          setTimeout(() => this.equalizeCardHeights(), 500);
        },
        resize: () => {
          this.equalizeCardHeights();
        },
      },
    });
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('recommendProducts', recommendProducts);
});
